import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { VisitTypeViewControllerDelegate, VisitTypeViewController } from "../../Screen/VisitType/VisitTypeViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { VisitTypeViewModel } from '../../Screen/VisitType/VisitTypeViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class VisitTypeCoordinator implements IndexCoordinatorDelegate, VisitTypeViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geptipovisita")
        return (<ProtectedRoute requiredPermissions={['dengue.tipo_visita.*']} path="/:base/dengue/tipo-visita" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.tipo_visita.adicionar',
                    edit: 'dengue.tipo_visita.editar',
                    delete: 'dengue.tipo_visita.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Tipo de Visita"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new VisitTypeViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.tipo_visita.adicionar', 'dengue.tipo_visita.editar']} path="/:base/dengue/tipo-visita/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<VisitTypeViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geptipovisita") {
            navigation.history.push(`tipo-visita/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geptipovisita") {
            navigation.history.push(`tipo-visita/cad/${idSelection}`);
            return;
        }
    }

}